var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("treeselect", {
    staticClass: "splicing-treeselect",
    attrs: {
      value: _vm.selection,
      options: _vm.options,
      placeholder: _vm.placeholder,
      "load-options": _vm.loadOptions,
      normalizer: _vm.normalizer,
      "default-expand-level": 2,
      disabled: _vm.disabled,
      valueFormat: "object",
      "value-consists-of": "LEAF_PRIORITY",
      "sort-value-by": "INDEX",
      multiple: "",
      disableFuzzyMatching: ""
    },
    on: { input: _vm.selectObjects }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-970b9800", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-970b9800","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectOptions.vue
// module id = null
// module chunks = 